export enum PublicSignerType {
	Witness = 'witness',
	Representative = 'representative',
	Counterparty = 'counterparty',
	Certifier = 'certifier',
}
